module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-avatar', {
    attrs: {
      "icon": "date_range"
    }
  }), _vm._v(" "), _c('label', [_vm._v("日期选择器")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34cd3a32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/muse-ui/datePicker.vue
// module id = 544
// module chunks = 1